import React, { Children, useRef, useEffect, useState, memo } from 'react';
import PropTypes from 'prop-types';

const Sticky = memo((props) => {
  const tickingRef = useRef(false);
  const lastScrollYRef = useRef(0);
  const [state, setState] = useState({});
  const stickyRef = useRef();
  const prevStickyRef = useRef(state.sticky);

  const handleScroll = () => {
    let { position, height = 0, offset = 0 } = props;
    lastScrollYRef.current = window.scrollY;
    let { current } = stickyRef;

    if (!tickingRef.current && current) {
      window.requestAnimationFrame(() => {
        let { top } = current.getBoundingClientRect();
        let browserHeight = window.innerHeight;
        let shouldStick;
        if (position === 'bottom'){
          shouldStick = lastScrollYRef.current + browserHeight < lastScrollYRef.current + top + height;
        } else {
          shouldStick = lastScrollYRef.current >= (lastScrollYRef.current + top) - offset;
        }

        /* istanbul ignore next */
        if (shouldStick !== state.sticky) {
          setState(prevState => ({
            ...prevState,
            sticky: shouldStick
          }));
        }

        tickingRef.current = false;
      });

      tickingRef.current = true;
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [props.position, props.height, props.offset]);

  useEffect(() => {
    if (prevStickyRef.current !== state.sticky && props.onChange) {
      props.onChange(state.sticky);
    }
    prevStickyRef.current = state.sticky;
  }, [state.sticky, props.onChange]);

  let { sticky } = state;
  let { children } = props;
  return <div ref={stickyRef} className="sticky-scroll">
    {Children.map(children, child => {
      return React.cloneElement(child, {
        sticky
      });
    })}
  </div>;
});

Sticky.displayName = 'Sticky';

Sticky.propTypes = {
  children: PropTypes.node,
  height: PropTypes.number,
  offset: PropTypes.number,
  onChange: PropTypes.func,
  position: PropTypes.string,
};

export default Sticky;
